import React from 'react';
import { Sparkles } from 'lucide-react';
import MagneticButton from './MagneticButton';
import '../styles/Home.css';

const PremiumCTA = () => {
  const handleContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="premium-cta">
      <div className="container">
        <div className="premium-cta-content">
          <h2>Stwórzmy Coś Wyjątkowego</h2>
          <p>
            Premium sklep e-commerce zaprojektowany specjalnie dla Twojej marki. 
            Kinematograficzne wizualizacje i płynne interakcje, które zwiększają konwersję.
          </p>
          <MagneticButton 
            className="btn-primary btn-glow"
            onClick={handleContact}
          >
            <Sparkles size={20} />
            Rozpocznij Projekt
          </MagneticButton>
        </div>
      </div>
    </section>
  );
};

export default PremiumCTA;
